import { SellerInfo } from '../components/SellerInfo';
import { useSellerInfoService } from '../services/useSellerInfoService';

export const ContactSellerInfoContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useSellerInfoService();

  if (service.isHide) {
    return null;
  }

  return (
    <SellerInfo
      isOpened={service.isOpened}
      country={service.country}
      toggle={service.toggle}
      sellerInfo={service.sellerInfo}
    />
  );
};
